<template lang="pug">

  .register-card-init-form
    form(@submit.prevent="check", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row(:form="form", name="number", :label="$t('card_auth_form.number')")
        form-input.playcard-control(:form="form", name="number", :placeholder="$t('card_auth_form.number_placeholder')" autocomplete="off")
        what-is-this-number-link
      form-group-row(:form="form", name="cvv", :label="$t('card_auth_form.cvv')")
        form-input.cvv-control(:form="form", name="cvv", type="password", :placeholder="$t('card_auth_form.cvv_placeholder')" autocomplete="off")
        what-is-this-cvv-link
      .form-group.no-check
        v-button.btn-default(:loading="form.busy", block) {{ $t('register_card.submit') }}

</template>

<script>
import Form from 'vform';
import Cookie from 'js-cookie';

export default {
  name: 'register-card-init-form',

  data: () => ({
    form: new Form({
      number: '',
      cvv: ''
    })
  }),

  methods: {
    async check () {
      await this.form.post(`${window.addiesaas.url}/api/playcards/playcard/add/validate`);
      Cookie.set('playcard', this.form.data());
      this.$router.push({ name: 'user.register', query: { extra_cookie: 'playcard' } });
    }
  }
}
</script>
